import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageName'
})
export class ImageNamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // staging
    // const newImg = 'https://d11n0xe80534si.cloudfront.net/images/'+value;

    // live
    const newImg = 'https://d3og0rqnoe5eci.cloudfront.net/images/'+value;
     
    return newImg;
  }

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/shared/pipes/image-name.pipe.ts